// extracted by css-extract-rspack-plugin
export default {"file-name-overflow":"ConversationHeader-module__file-name-overflow__s0Wp7iG"};